/**
 * TanStack Query mutation for submitting KYC form via tRPC.
 */

import { useQueryClient } from "@tanstack/react-query";
import { transformDBKYBToKYCFormData } from "../services/data/api/kycProvider";
import { trpc } from "../trpc";

export function useKYBSubmit() {
	const queryClient = useQueryClient();
	const utils = trpc.useUtils();

	const mutation = trpc.kyb.submit.useMutation({
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({ queryKey: ["kyb", variables.id] });
			utils.kyb.list.invalidate();
		},
	});

	return {
		...mutation,
		mutate: (formId: string) => {
			mutation.mutate({ id: formId });
		},
		mutateAsync: async (formId: string) => {
			const result = await mutation.mutateAsync({ id: formId });
			return transformDBKYBToKYCFormData(result);
		},
	};
}
